export default "__VITE_ASSET__D5J9lD7y__"